import { __assign } from "tslib";
import { BrowserTracing } from './browser';
import { addExtensionMethods } from './hubextensions';
import * as ApmIntegrations from './integrations';
var Integrations = __assign(__assign({}, ApmIntegrations), { BrowserTracing: BrowserTracing });
export { Integrations };
export { Span, TRACEPARENT_REGEXP } from './span';
export { Transaction } from './transaction';
export { SpanStatus } from './spanstatus';
// We are patching the global object with our hub extension methods
addExtensionMethods();
export { addExtensionMethods };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/tracing/esm/index.js
// module id = 643
// module chunks = 92